export default [
  {
    path: '/documentos',
    name: 'documentos',
    component: () => import(/* webpackChunkName: "documentos" */ '../../views/documentos/Documentos')
  },
  {
    path: '/administracao-documentos',
    name: 'documentos-administracao',
    component: () => import(/* webpackChunkName: "documentos-administracao" */ '../../views/documentos/DocumentosAdministracao')
  },
  {
    path: '/documentos/cadastro',
    name: 'cadastro-documentos',
    component: () => import(/* webpackChunkName: "cadastro-documentos" */ '../../views/documentos/Cadastro')
  },
  {
    path: '/documentos/cadastro/:id',
    name: 'edicao-documentos',
    component: () => import(/* webpackChunkName: "edicao-documentos" */ '../../views/documentos/Cadastro')
  }
]
